// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.handwritten-signature-question .handwritten-signature-line {
    border: 1px solid var(--survey-border-color);
    margin-left: 30px;
    margin-right: 30px;
    border-bottom: solid 1px var(--survey-border-color-strong);
    color: var(--survey-text-color-5);
    font-size: 14px;
    text-align: left;
}

.handwritten-signature-question .handwritten-signature-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.handwritten-signature-question .handwritten-signature-clear-button {
    margin-top: 16px;
    font-size: 14px;
    /* admin's --blue does not exist on participant survey pages */
    color: var(--survey-accent-color);
    background: none;
    border: none;
    cursor: pointer;
}

.survey-form-item.handwritten-signature-question-no-label {
    margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Survey/Questions/SignatureQuestion/SignatureQuestion.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,iBAAiB;IACjB,kBAAkB;IAClB,0DAA0D;IAC1D,iCAAiC;IACjC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,8DAA8D;IAC9D,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".handwritten-signature-question .handwritten-signature-line {\n    border: 1px solid var(--survey-border-color);\n    margin-left: 30px;\n    margin-right: 30px;\n    border-bottom: solid 1px var(--survey-border-color-strong);\n    color: var(--survey-text-color-5);\n    font-size: 14px;\n    text-align: left;\n}\n\n.handwritten-signature-question .handwritten-signature-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.handwritten-signature-question .handwritten-signature-clear-button {\n    margin-top: 16px;\n    font-size: 14px;\n    /* admin's --blue does not exist on participant survey pages */\n    color: var(--survey-accent-color);\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.survey-form-item.handwritten-signature-question-no-label {\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
